import { render, staticRenderFns } from "./DRCreate.vue?vue&type=template&id=ac90a996&"
import script from "./DRCreate.vue?vue&type=script&lang=js&"
export * from "./DRCreate.vue?vue&type=script&lang=js&"
import style0 from "./DRCreate.vue?vue&type=style&index=0&id=ac90a996&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports